import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ModalComponent from '../../../../../features/components/customComponents/ModalComponent/ModalComponent.jsx';
import useAuth from '../../../../../app/hooks/useAuth';
import { createMessage } from '../../../../../app/redux/slices/app/messageSlice';
import { CircularProgress } from '@mui/material';

const CreateMessage = props => {
  const { modalOpen, setModalOpen } = props;
  const dispatch = useDispatch();
  const { user } = useAuth();
  const [loader, setLoader] = useState(false);
  const [validation, setValidation] = useState([]);

  const { selectedAccount, userAccountDetails } = useSelector(state => state?.userDetailSlice);

  const [value, setValue] = useState({
    name: user?.first_name + ' ' + user?.last_name,
    street_address: selectedAccount?.street_address,
    created_date: new Date().toLocaleDateString(),
    user_type_code: userAccountDetails?.userAccountInfo?.userTypeCode,
    crm_premise_id: selectedAccount?.crm_premise_id,
    crm_service_account_id: selectedAccount?.crm_service_account_id,
    crm_contact_id: userAccountDetails?.userAccountInfo?.crm_contact_id,
    title: '',
    description: ''
  });

  const validationForm = async () => {
    let errorList = [];
    if (!value.title.trim()) errorList.title = 'Title is required';
    if (!value.description.trim()) errorList.description = 'Description is required';

    return errorList;
  };

  const btnSubmit = async () => {
    setLoader(true);
    var validationErrors = await validationForm();
    if (Object.keys(validationErrors).length > 0) {
      setValidation(validationErrors);
      setLoader(false);
    } else {
      dispatch(createMessage({ ...value })).then(() => {
        setValue({
          name: user?.first_name + ' ' + user?.last_name,
          street_address: selectedAccount?.street_address,
          created_date: new Date().toLocaleDateString(),
          user_type_code: userAccountDetails?.userAccountInfo?.userTypeCode,
          crm_premise_id: selectedAccount?.crm_premise_id,
          crm_service_account_id: selectedAccount?.crm_service_account_id,
          crm_contact_id: userAccountDetails?.userAccountInfo?.crm_contact_id,
          title: '',
          description: ''
        });
        setModalOpen(false);
        setLoader(false);
      });
    }
  };

  return (
    <>
      <ModalComponent
        mainheading={'Create a message'}
        openModal={modalOpen}
        modalId="createMessage"
        modalContent={
          <>
            <form className="">
              <div className="form-group">
                <label>
                  Subject<span className="">*</span>
                </label>
                <input
                  type="text"
                  value={value.title}
                  required
                  maxLength={500}
                  onChange={e => {
                    e.preventDefault();
                    setValue({ ...value, title: e.target.value });
                  }}
                  className="form-control"
                  placeholder="Enter the subject/title"
                />
                {validation.title && <span style={{ color: 'red' }}>{validation.title}</span>}
              </div>
              <div className="form-group">
                <label>
                  Description <span className="">*</span>
                </label>
                <textarea
                  className="form-control"
                  name=""
                  maxLength={3000}
                  value={value.description}
                  required
                  onChange={e => {
                    e.preventDefault();
                    setValue({ ...value, description: e.target.value });
                  }}
                  id=""
                  rows="3"
                ></textarea>
                {validation.description && (
                  <span style={{ color: 'red' }}>{validation.description}</span>
                )}
              </div>
              <div className="control_buttons text-center">
                <button
                  type="button"
                  onClick={e => {
                    e.preventDefault();
                    setModalOpen(false);
                  }}
                  className="btn btn-custom startlit_navy"
                >
                  Close
                </button>{' '}
                &nbsp;
                <button
                  type="submit"
                  className="btn btn-custom electric_cobalt"
                  onClick={e => {
                    e.preventDefault();
                    btnSubmit();
                  }}
                >
                  {loader ? <CircularProgress size={22} /> : 'Submit'}
                </button>
              </div>
            </form>
          </>
        }
        onClose={() => {
          setModalOpen(false);
        }}
      />
    </>
  );
};

export default CreateMessage;
